import React from 'react'
import { connect } from 'react-redux'
import * as p from 'prop-types'
import createReactClass from 'create-react-class'
import _ from 'underscore'
import xtend from 'xtend'
import moment from 'moment'
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle'
import { FormGroup, ControlLabel, FormControl, Table, Modal as RBModal } from 'react-bootstrap'
import { Link, Redirect } from 'react-router-dom'
import QueryString from 'query-string'
import {
  ListItem,
} from '@material-ui/core'
import clsx from 'clsx'
import PrivateIcon from '@material-ui/icons/Public'

import Formatter from '../../../utils/Formatter.js'
import Loader from '../../../common/components/notifications/Loader'
import AudioDescriptionIcon from '../../../common/components/AudioDescriptionIcon'
import EventInfoTable from './lib/event-info-table'
import EventQuickAnalytics from './lib/event-quick-analytics'
import ChatModal from './chat/ChatModal'
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent'
import store from '../../../redux/store.js'
import actions from '../../../redux/actions.js'
import config from '../../../config.js'
import history from '../../../history.js'
import { GET_FULL_EVENT } from '../../../redux/data/types.js'
import { EVENT_VIEW_TYPES } from '../../../redux/events/reducers.js'
import { getEventStartStopPending, getHasRequestPending } from '../../../redux/data/selectors.js'
import SlimEvent from './SlimEvent.js'
import GridEvent from './GridEvent.js'
import EncoderSelector from './encoder-select/EncoderSelector.js'
import RecordActions from './recordActions'
import PreviewSources from './PreviewSources'
import schema from '../../../routes/permissions/schema.js'

// chat type constants
var CHAT_MODERATED = 2

// function Chat (opts) {
//     return xtend({
//         enabled: false,
//         chatTypeID: 0,
//         isLoginEnabled: false,
//         loginPass: null
//     }, opts);
// }

export function getStatusAsClassName(status) {
  switch (status.toLowerCase()) {
    case 'on break':
      return 'onBreak'
    default:
      return status.toLowerCase()
  }
}

function validateCustomId(str) {
  return /^[a-zA-Z _\-\[\]\&\d]+$/.test(str)
}

function hasVideoAsset(assets) {
  if (!assets || !_.isArray(assets)) return false
  let withVideo = false
  assets.map((asset) => {
    if (asset.type == 'video') withVideo = true
  })
  return withVideo
}

const getModerators = (eventId, clientId) => {
  store.dispatch(
    actions.request.sendRequest({
      type: 'GET_EVENT_MODERATORS',
      url: `${config.chat.rest}getModerators`,
      postData: {
        data: {
          type: 'getModerators',
          eventId,
          clientId,
        },
      },
    })
  )
}

// function getStoreState (id) {
//     return {
//         // preview: PreviewStore.getEventPreview(id || ''),
//         deleteModal: false,
//         customIdModal: false,
//         customIdEdits: null,
//         encoderSelect: false
//     };
// }

var QuickLook = createReactClass({
  PropTypes: {
    event: p.object.isRequired,
    encoderActions: p.object.isRequired,
    encoders: p.object.isRequired,
    toggleActiveEvent: p.func.isRequired,
    actions: p.shape({
      edit: p.func.isRequired,
      delete: p.func.isRequired,
      start: p.func.isRequired,
      stop: p.func.isRequired,
    }).isRequired,
  },

  getInitialState: function () {
    return {
      deleteModal: false,
      customIdModal: false,
      customIdEdits: null,
      encoderSelect: false,
      chatModal: false,
      showStopModal: false,
      // preview: null,
      redirect: false,
      // chatSettings: {},
      windowWidth: window.innerWidth
    }
  },
  componentDidUpdate: function (prevProps, prevState) {
    const eventFullyLoaded =
      this.props.event &&
      !this.props.event.isSlim &&
      this.props.event.mediaAssets
    const isLiveGridEvent =
      this.props.viewType === EVENT_VIEW_TYPES.GRID.key &&
      ['live', 'on break', 'starting', 'stopping'].includes(this.props.event.eventStatus)

    const showExpanded =
      (this.props.viewType === EVENT_VIEW_TYPES.SLIM.key &&
        !!this.props.isExpanded) ||
      this.props.activeEvent ||
      isLiveGridEvent
    const prevShowExpanded = prevProps.eventViewType.key === EVENT_VIEW_TYPES.SLIM.key && !!prevProps.isExpanded || prevProps.activeEvent
    if (!this.props.requestingEvent && !eventFullyLoaded && showExpanded && (showExpanded !== prevShowExpanded || (!this.props.requestingEvent && this.props.requestingEvent === prevProps.requestingEvent))) {
      this.props.getFullEvent(this.props.event.eventID)
    }

    // stop requesting analytics for events when the user leaves the quicklook view for that event
    if (this.state.analyticsTimer && !this.props.activeEvent) {
      clearInterval(this.state.analyticsTimer)
    }
  },
  handleResize: function() {
    this.setState({windowWidth: window.innerWidth})
  },
  componentDidMount: function() {
    window.addEventListener("resize", this.handleResize);
  },
  componentWillUnmount: function () {
    window.addEventListener("resize", null);
    if (this.state.analyticsTimer) {
      clearInterval(this.state.analyticsTimer)
    }
  },

  /*
        Modals
     */
  toggleDeleteModal: function () {
    this.setState({
      deleteModal: !this.state.deleteModal,
    })
  },

  toggleCustomIdModal: function (event) {
    if (event) event.preventDefault()
    this.setState({
      customIdModal: !this.state.customIdModal,
      customIdEdits: null,
    })
  },

  /*
        State internals
     */
  toggleFullscreen: function (event) {
    event && event.preventDefault()
    if (this.props.event.mediaAssets === undefined) {
      this.props.getFullEvent(this.props.event.eventID)
    }
    this.props.toggleActiveEvent(this.props.event.eventID)
    // remove tab from querystring
    let qs = QueryString.parse(history.location.search)
    delete qs.tab
    history.push(`${history.location.pathname}?${QueryString.stringify(qs)}`)
  },

  openEditor: function () {
    // history.push('/editor?eventID=' + this.props.event.eventID)
    this.setState({
      redirect: '/editor?eventID=' + this.props.event.eventID,
    })
  },

  openAgenda: function () {
    const event = this.props.event
    const publishedAsset =
      (event.eventStatus === 'published' &&
        event.mediaAssets.find(
          (asset) => asset.type === 'video' && asset.currentStatus === 'archive'
        )) ||
      null
    const agendaPath =
      event.eventStatus !== 'published'
        ? `/agenda?eventID=${event.eventID}`
        : `/agenda?eventID=${event.eventID}&assetID=${publishedAsset && publishedAsset.assetID}`
    this.setState({
      redirect: agendaPath,
    })
  },

  getAdStudioLaunchUrl: function () {
    const event = this.props.event
    const baseUrl = ((config.apps && config.apps.audioDescriptionStudio) || 'https://ad.invintus.com').replace(/\/$/, '')

    // Existing project → deep-link. The backend now returns
    // audioDescriptionProjectID on Console/getEvent + getEventsSlim, so we
    // can route straight to the project page in AD Studio without re-bootstrapping.
    if (event.audioDescriptionProjectID) {
      return `${baseUrl}/projects/${event.audioDescriptionProjectID}`
    }

    // No project yet → bootstrap from the published video asset.
    const mediaAssets = Array.isArray(event.mediaAssets) ? event.mediaAssets : []
    const publishedVideoAsset =
      event.eventStatus === 'published'
        ? mediaAssets.find(
            (asset) =>
              asset &&
              asset.type === 'video' &&
              asset.assetID &&
              asset.currentStatus &&
              String(asset.currentStatus).toLowerCase() === 'archive'
          )
        : null

    if (!publishedVideoAsset) {
      return 'about:blank'
    }

    const transcriptUrl = event.captionPath && String(event.captionPath).trim()
      ? String(event.captionPath).trim()
      : undefined

    const mediaUrl = `https://api.v3.invintus.com/StreamURI/hls/${event.clientID}/${event.eventID}/media.m3u8`
    const params = {
      clientID: event.clientID,
      eventID: event.eventID,
      source: 'controlcenter',
      assetID: publishedVideoAsset.assetID,
      mediaUrl,
    }
    if (transcriptUrl) {
      params.transcriptUrl = transcriptUrl
    }
    const query = QueryString.stringify(params)
    return `${baseUrl}/?${query}`
  },

  deleteEvent: function () {
    this.props.actions.delete({
      eventID: this.props.event.eventID,
    })
  },

  handleCustomIdSubmit: function (ev) {
    ev.preventDefault()
    // var self = this;
    var id = ev.target.elements.customID.value
    this.toggleCustomIdModal()
    this.props.actions.edit(
      {
        customID: id,
        eventID: this.props.event.eventID,
      },
      function (err, data) {
        if (err) {
          return
        }
      }
    )
  },

  /*
        Server/Api Updates
     */
  assignEncoder: function (encID) {
    this.props.actions.edit({
      eventID: this.props.event.eventID,
      encoderID: encID,
    })
  },

  handleRecord: function () {
    this.props.actions.start({
      eventID: this.props.event.eventID,
    })
  },

  handlePause: function () {
    var newStatus = this.props.event.eventStatus === 'live' ? 3 : 2
    var liveStats = this.props.event.liveStats

    this.props.actions.edit({
      eventID: this.props.event.eventID,
      liveID: liveStats.liveID,
      eventStatus: newStatus,
    })
  },

  confirmStop: function (ev) {
    this.props.actions.stop({
      eventID: this.props.event.eventID,
    })
    this.setState({ showStopModal: false })
  },

  hideStopModal: function (ev) {
    this.setState({ showStopModal: false })
  },

  handleStop: function () {
    this.setState({ showStopModal: true })
  },

  render: function () {
    if (this.state.redirect) {
      return (
        <Redirect key={this.props.event.eventID} to={this.state.redirect} />
      )
    }
    if (
      this.props.activeEvent ||
      this.props.eventViewType.key === EVENT_VIEW_TYPES.EXPANDED.key
    ) {
      return this.renderFull()
    } else if (this.props.eventViewType.key === EVENT_VIEW_TYPES.SLIM.key) {
      return (
        <SlimEvent
          {...this.props}
          isExpanded={this.props.isExpanded}
          getStatusAsClassName={getStatusAsClassName}
          assignEncoder={this.assignEncoder}
          renderQuickLook={this.renderQuickLook}
          handleRecord={this.handleRecord}
          handlePause={this.handlePause}
          handleStop={this.handleStop}
        />
      )
    } else if (this.props.eventViewType.key === EVENT_VIEW_TYPES.GRID.key) {
      return (
        <GridEvent
          {...this.props}
          handlePause={this.handlePause}
          handleRecord={this.handleRecord}
          handleStop={this.confirmStop}
          toggleFullscreen={this.toggleFullscreen}
          getStatusAsClassName={getStatusAsClassName}
          renderQuickLook={this.renderQuickLook}
        />
      )
    } else {
      return this.renderFull()
    }
  },
  renderFull: function () {
    if (this.props.event === undefined) return null
    return (
      <ListItem style={{ flexWrap: 'wrap', padding: 0 }}>
        {this.renderTitle()}
        {this.renderQuickLook()}
      </ListItem>
    )
  },

  renderTitle: function () {
    var clientTZabbr = moment.tz(this.props.timeZone).format('z')
    var startDate = this.props.event.startDateTime
    return (
      <div className='event-header'>
        <div className='title'>{this.props.event.title}</div>
        <div className='date'>{Formatter.getHeadingDateFormat(startDate) + ' ' + clientTZabbr}</div>
      </div>
    )
  },

  openChatSettings: function (ev) {
    if (ev) ev.preventDefault()
    var type = this.props.event.chat?.chatTypeID
    if (type == CHAT_MODERATED) {
      const eventId = this.props.event.eventID
      const clientId = this.props.event.clientID
      this.props.chatActions.getModerators({ data: { type: 'getModerators', eventId, clientId } })
    }
    this.setState({ chatModal: true })
    // getModerators('2020101007', '1000000000')
  },

  closeChatSettings: function () {
    this.setState({ chatModal: false })
  },

  // @TODO -- new event type "enable with mod"
  saveChatSettings: function (ev) {
    this.closeChatSettings()
    // this.props.chatActions.enableChatWithModerator(...)
    this.props.actions.edit({
      eventID: this.props.event.eventID,
      chat: ev,
    })
  },

  handleChatFieldChange: function (ev) {
    var name = ev.target.name
    var data = {}
    data[name] = ev.target.value
    this.setState({
      chatSettings: xtend(this.state.chatSettings, data),
    })
  },

  addMod: function (ev) {
    if (ev) ev.preventDefault()
    this.setState({ addingMod: true })
  },

  cancelMod: function () {
    this.setState({ addingMod: false })
  },

  saveMod: function (mod) {
    this.props.chatActions.createModerator({
      eventID: this.props.event.eventID,
      name: mod.name,
      email: mod.email.toLowerCase(),
    })
  },

  renderChatModal: function () {
    return (
      <ChatModal
        {...this.props}
        show={this.state.chatModal}
        onHide={this.closeChatSettings}
        onSubmit={this.saveChatSettings}
        onCreateModerator={this.saveMod}
      />
    )
  },

  renderQuickLook: function () {
    // only show the loader for the entire quicklook if the event is being published
    // otherwise show the loader where the components are being updated
    // ajaxstate examples:
    // undefined, {eventID: , assetID: }, {eventID, title, eventNotes, private, startDateTime, description, liveCaptions}, {eventID, chat:{...}}
    
    const showExpanded = !!(this.props.activeEvent)

    const eventFullyLoaded = this.props.event && !this.props.event.isSlim
    const encoderChanging = this.props.encoderChanging
    if (showExpanded) {
      //request event analytics
      if(!this.state.analyticsTimer) {
        const requestDelayMs = 10000
        const timer = setInterval(() => {
          if (!this.props.requestingAnalytics) {
            this.props.requestEventAnalytics([this.props.event.eventID])
          }
        }, requestDelayMs)
        this.setState({analyticsTimer: timer})
        // request the analytics once before the timer's first call 
        this.props.requestEventAnalytics([this.props.event.eventID])
      }
    }

    if (
      ((this.props.ajaxState &&
      this.props.ajaxState.encoderID &&
      this.props.ajaxState.encoderID !== this.props.event.assignedEncoder) || encoderChanging) &&
      this.state.preview !== null &&
      this.state.preview && this.state.preview.type !== 'asset'
    ) {
      // set preview to null when encoder changes and video isn't published
      this.setState({ preview: null })
    }

    const isSmallScreen = this.state.windowWidth < 768
    const assignedEncoder = this.props.event.assignedEncoder && this.props.encoders.data.find(encoder => encoder.encoderID === this.props.event.assignedEncoder )
    const encoderIsOnline = assignedEncoder && assignedEncoder.online
    const eventIsPublished = this.props.event.eventStatus === 'published'

    return (
      //when to show loader over everything
      !eventFullyLoaded ||
        this.props.requestingEvent ||
        (this.props.event.eventStatus !== 'published' && encoderChanging) ? (
        <div
          style={{ backgroundColor: 'rgba(0,0,0,0.1)' }}
          className={clsx('event-quicklook clearfix', showExpanded ? 'expanded' : 'minimized')}
        >
          <Loader message='Updating' />
        </div>
      ) : (
        <div className={clsx('event-quicklook clearfix', showExpanded ? 'expanded' : 'minimized')}>
          {this.renderChatModal()}
          {this.renderModals()}

          <StopModal
            show={this.state.showStopModal}
            event={this.props.event}
            onHide={this.hideStopModal}
            onConfirm={this.confirmStop}
          />

          {!isSmallScreen || eventIsPublished || encoderIsOnline ? <div className='col-xs-12 col-sm-4 event-quicklook-section'>
            <PreviewSources
              event={this.props.event}
              encoders={this.props.encoders}
            />

            {this.props.ajaxState || this.props.updatingInnerQuicklook ? (
              <div className='event-quicklook'>{/* <Loader message="Updating"/> */}</div>
            ) : (
              <div className='col-xs-2 vertical-button-group'>
                <RecordActions
                  event={this.props.event}
                  encoders={this.props.encoders}
                  handleRecord={this.handleRecord}
                  handleStop={this.handleStop}
                  handlePause={this.handlePause}
                />
              </div>
            )}
          </div> : null}

          {this.props.ajaxState || this.props.updatingInnerQuicklook ? (
            <div className='event-quicklook'>
              <Loader message='Updating' />
            </div>
          ) : (
            <div className='col-xs-12 col-sm-4 event-quicklook-section'>
              <EncoderSelector
                event={this.props.event}
                encoders={this.props.encoders.data}
                assignEncoder={this.assignEncoder}
                isResolving={this.props.encoders.isResolving}
                startStopPending={this.props.startStopPending}
                actions={this.props.encoderActions}
              />
              <div className='event-information'>
                {this.renderToggles()}
                {this.renderEventMetadata()}
              </div>
            </div>
          )}

          {this.props.ajaxState || this.props.updatingInnerQuicklook ? (
            <div className='event-quicklook'>{/* <Loader message="Updating"/> */}</div>
          ) : (
            <div className='col-xs-12 col-sm-4 event-quicklook-section'>
              <div className='col-xs-10'>
                <div>
                  <div className='col-xs-6'>
                    <div className={'event-status ' + getStatusAsClassName(this.props.event.eventStatus)}>
                      {this.props.event.eventStatus}
                    </div>
                  </div>
                  <a
                    href='about:blank'
                    className='col-xs-6 asset-count'
                    onClick={e => {
                      e.preventDefault()
                      if (!this.props.activeEvent) {
                        this.props.toggleActiveEvent(this.props.event.eventID)
                      }
                      
                      const qs = QueryString.parse(location.search)
                      qs.tab = 'assets'
                      history.push(`${window.location.pathname}?${QueryString.stringify(qs)}`)
                      this.props.setTab('assets')
                    }}
                  >
                    <span style={{fontSize: '13px'}} className='badge'>
                      {this.props.event.mediaAssets.length}
                    </span> Assets
                  </a>
                </div>
                <div>
                  <EventInfoTable timeZone={this.props.timeZone} event={this.props.event} />
                </div>
              </div>
              <div className='col-xs-2 vertical-button-group action-buttons'>
                {this.renderEditActions()}
              </div>
            </div>
          )}
        </div>
      )
    )
  },

  renderEditActions: function () {
    var _status = this.props.event.eventStatus
    let hasVideo = hasVideoAsset(this.props.event.mediaAssets)
    const hasPublishedVideoAsset =
      this.props.event.eventStatus === 'published' &&
      Array.isArray(this.props.event.mediaAssets) &&
      this.props.event.mediaAssets.some(
        (asset) =>
          asset &&
          asset.type === 'video' &&
          asset.assetID &&
          asset.currentStatus &&
          String(asset.currentStatus).toLowerCase() === 'archive'
      )
    const hasTranscriptVtt = Boolean(
      this.props.event.captionPath && String(this.props.event.captionPath).trim()
    )
    // TODO: Gate AD Studio launch on hasTranscriptVtt once VTT availability is more reliable
    const adStudioEnabled = hasPublishedVideoAsset

    var disabled = _status === 'publishing' || _status === 'unpublishing'

    switch (this.props.event.eventStatus) {
      case 'publishing':
      case 'unpublishing':
      case 'editing':
      case 'published':
      case 'on break':
      case 'live':
      case 'disconnected':
      case 'starting':
      case 'stopping':
        disabled = true;
        break;
    }

    var actions = []

    actions.push(
      <RestrictedComponent permissionCheck={true} key='fullscreen'>
        <button
          title={this.props.isActive ? 'Back' : 'Edit'}
          key='fullscreen'
          type='button'
          className='btn edit'
          onClick={this.toggleFullscreen}
        >
          {this.props.isActive ? (
            <i className='fa fa-arrow-left' />
          ) : (
            <i className='fa fa-pencil' />
          )}
        </button>
      </RestrictedComponent>
    )

    actions.push(
      <RestrictedComponent permissionCheck={schema.EVENT_VIDEO_EDITOR.READ} key='editor'>
        <button
          title='Video Editor'
          key='editor'
          type='button'
          className='btn editor'
          onClick={this.openEditor}
          disabled={disabled || !hasVideo}
        >
          <i className='fa fa-film' />
        </button>
      </RestrictedComponent>
    )

    actions.push(
      <RestrictedComponent permissionCheck={schema.EVENT_VIDEO_EDITOR.READ} key='ad-studio'>
        <a
          title={adStudioEnabled ? 'Open AD Studio' : 'AD Studio requires a published video asset'}
          key='ad-studio'
          className='btn editor'
          href={this.getAdStudioLaunchUrl()}
          target='_blank'
          rel='noopener noreferrer'
          aria-disabled={!adStudioEnabled}
          tabIndex={!adStudioEnabled ? -1 : 0}
          onClick={e => {
            if (!adStudioEnabled) {
              e.preventDefault()
              return
            }
          }}
        >
          <AudioDescriptionIcon size={18} />
        </a>
      </RestrictedComponent>
    )

    actions.push(
      <RestrictedComponent permissionCheck={schema.AGENDA_EVENT.READ} key='agenda'>
        <button
          title='Agenda'
          key='agenda'
          type='button'
          className='btn agenda'
          onClick={this.openAgenda}
        >
          <i className='fa fa-list-ol' />
        </button>
      </RestrictedComponent>
    )

    actions.push(
      <RestrictedComponent permissionCheck={schema.EVENT.DELETE} key='delete'>
        <button
          data-testid={`delete-event-button-${this.props.event.title}`}
          title='Delete Event'
          key='delete'
          type='button'
          className='btn delete'
          onClick={this.toggleDeleteModal}
          disabled={disabled}
        >
          <i className='fa fa-trash-can' />
        </button>
      </RestrictedComponent>
    )

    return actions
  },

  validateCustomId: function (ev) {
    var val = ev.target.value
    var valid = validateCustomId(val)
    if (this.state.validCustomId !== valid) {
      this.setState({ validCustomId: valid })
    }
  },

  renderToggles: function () {
    return (
      <div className='toggles clearfix'>
        <div className='col-xs-3'>
          <span
            style={{
              display: 'inline-flex',
              marginRight: '0.5ch',
            }}
            title={this.props.event.private ? 'Private' : 'Public'}
            className={clsx(
              'public-status-icon',
              this.props.event.private && 'private-status-icon'
            )}
          >
            <PrivateIcon />
          </span>
          <span>{this.props.event.private ? 'Private' : 'Public'}</span>
        </div>
        <div className='col-xs-3'>
          <i
            className={
              'fa fa-circle' + (this.props.event.autoStart ? ' success' : '-o')
            }
          />
          <span>Auto Start</span>
        </div>
        <div className='col-xs-3'>
          <i
            className={
              'fa fa-circle' + (this.props.event.autoStop ? ' success' : '-o')
            }
          />
          <span>Auto Stop</span>
        </div>
        <div
          className='col-xs-3'
          title={
            this.props.event.liveAiCaptions.isEnabled
              ? 'Live AI captions are enabled, they can be disabled in the general tab'
              : 'Live AI captions are disabled, they can be enabled in the general tab'
          }
        >
          <i
            className={
              'fa fa-closed-captioning' +
              (this.props.event.liveAiCaptions.isEnabled ? ' success' : '')
            }
            onClick={() => {
              const queryString = QueryString.parse(location.search)
              const eventID = this.props.event.eventID
              queryString.tab = 'general'
              queryString.eventID = eventID
              // only select an event if there wasn't one previously
              // otherwise it would close the selected event
              if (!this.props.activeEvent) {
                this.props.toggleActiveEvent(eventID)
              }
              history.push(`${window.location.pathname}?${QueryString.stringify(queryString)}`)
              this.props.setTab('general')
            }}
          />
        </div>
      </div>
    )
  },

  renderEventMetadata: function () {
    var eventID = this.props.event.eventID
    var customID = this.props.event.customID
    var enabled = this.props.event.chat?.enabled
    const eventStatus = this.props.event.eventStatus;

    const chatHost = config.chat.page
    var adminUrl = enabled
      ? chatHost +
        'clientID=' +
        this.props.event.clientID +
        '&' +
        'eventID=' +
        this.props.event.eventID
      : null

    return (
      <div>
        <Table bordered striped condensed>
          <tbody>
            <tr>
              <td className='data-label'>Event ID</td>
              <td className='data-value'>
                <Link to={'/events/?eventID=' + eventID}>{eventID}</Link>
              </td>
            </tr>
            <tr>
              <td className='data-label'>Custom ID</td>
              <td className='data-value'>
                {customID ? customID : <span className='not-set'>Not Set</span>}
                <span className='pull-right'>
                  <RestrictedComponent permissionCheck={schema.EVENT.UPDATE_CUSTOM_ID}>
                    <a
                      href='about:blank'
                      onClick={(ev) => {
                        ev.preventDefault()
                        this.toggleCustomIdModal()
                      }}
                    >
                      <i className='fa fa-pencil' />
                    </a>
                  </RestrictedComponent>
                </span>
              </td>
            </tr>

            <tr>
              <td className='data-label'>Live chat</td>
              <td className='data-label'>
                {this.props.event.chat?.enabled ? (
                  <span title='Open chat admin'>
                    <span
                      style={{
                        marginRight: '1em',
                      }}
                    >
                      Moderated
                    </span>
                    <span>
                      <a href={adminUrl} target='_blank'>
                        <i className='fa fa-external-link' aria-hidden='true'></i>
                      </a>
                    </span>
                  </span>
                ) : (
                  <em>none</em>
                )}

                <span className='pull-right'>
                  <RestrictedComponent permissionCheck={schema.EVENT.UPDATE_CHAT}>
                    <a
                      href='about:blank'
                      onClick={(ev) => {
                        ev.preventDefault()
                        this.openChatSettings()
                      }}
                      role='button'
                    >
                      <i className='fa fa-pencil' />
                    </a>
                  </RestrictedComponent>
                </span>
              </td>
            </tr>
          </tbody>
        </Table>

        <EventQuickAnalytics eventID={eventID} eventStatus={eventStatus} />
      </div>
    )
  },

  renderModals: function () {
    if (this.state.deleteModal) {
      return (
        <RBModal
          animation={false}
          bsSize='large'
          show={this.state.deleteModal}
          onHide={this.toggleDeleteModal}
        >
          <RBModal.Header>
            <RBModal.Title>Delete Event</RBModal.Title>
          </RBModal.Header>
          <RBModal.Body>
            <div className='alert alert-danger'>
              <h4>This action cannot be undone!</h4>
              <p>Please confirm Event Deletion</p>
            </div>
          </RBModal.Body>
          <RBModal.Footer>
            <button className='btn btn-default' onClick={this.toggleDeleteModal}>
              Cancel
            </button>
            <button
              className='btn btn-danger'
              onClick={(e) => {
                // close modals before deleting
                if (this.state.deleteModal) this.toggleDeleteModal(e)
                if (this.props.isActive) this.toggleFullscreen(e)
                this.deleteEvent(e)
              }}
            >
              <i className='fa fa-trash-can' /> Delete
            </button>
          </RBModal.Footer>
        </RBModal>
      )
    } else if (this.state.customIdModal) {
      return (
        <RBModal
          bsSize='large'
          bsStyle='primary'
          show={this.state.customIdModal}
          onHide={this.toggleCustomIdModal}
        >
          <RBModal.Header>
            <RBModal.Title>Edit Custom ID</RBModal.Title>
          </RBModal.Header>

          <form onSubmit={this.handleCustomIdSubmit}>
            <RBModal.Body>
              <div className='alert alert-danger' role='alert'>
                <strong>Please Note:</strong> Editing the <code>customID</code> could make the event
                harder to find to other services that already use the existing <code>customID</code>
                . Please only edit this if you know the consequences.
              </div>
              <FormGroup validationState={this.state.validCustomId ? null : 'error'}>
                <ControlLabel>New Custom ID</ControlLabel>
                <FormControl
                  name='customID'
                  onChange={this.validateCustomId}
                  defaultValue={this.props.event.customID}
                ></FormControl>
              </FormGroup>
            </RBModal.Body>

            <RBModal.Footer>
              <button className='btn btn-default' onClick={this.toggleCustomIdModal}>
                Cancel
              </button>
              <button
                className='btn btn-primary'
                type='submit'
                disabled={!this.state.validCustomId}
              >
                <i className='fa fa-save'></i> Save
              </button>
            </RBModal.Footer>
          </form>
        </RBModal>
      )
    }
  },
})

export const StopModal = (props) => {
  const { event, onHide, show, onConfirm } = props
  return (
    <RBModal show={show} onHide={onHide}>
      <RBModal.Header closeButton>
        <RBModal.Title>
          <FaExclamationTriangle /> Confirm Live Stream/Record Stop
        </RBModal.Title>
      </RBModal.Header>

      <RBModal.Body>
        {show ? <div className='alert alert-danger text-danger'>
          <p>
            This will <strong>stop</strong> the <em>Live Event</em> stream/record for:
          </p>
          <ul>
            <li>
              <strong>{event.title}</strong> |{' '}
              <em>
                {moment(event.startDateTime, 'YYYY-MM-DD HH:mm:ss').format(
                  'MMM. DD YYYY, hh:mm:ss a'
                )}
              </em>
            </li>
          </ul>
        </div> : null}
      </RBModal.Body>

      <RBModal.Footer>
        <button className='btn btn-default' onClick={onHide}>
          Cancel
        </button>
        <button className='btn btn-danger' onClick={onConfirm}>
          Stop
        </button>
      </RBModal.Footer>
    </RBModal>
  )
}

const mapStateToProps = (state, ownProps) => {
  const eventID = ownProps.event.eventID
  const requestingEvent =
    state.request[GET_FULL_EVENT] &&
    state.request[GET_FULL_EVENT].pending &&
    state.request[GET_FULL_EVENT].postData.eventID === eventID
  const eventViewType = state.events.viewType
  const updatingInnerQuicklook = getHasRequestPending(state, ['BUS/http.events.edit']) && state.request['BUS/http.events.edit'].req.eventID === eventID
  const encoderChanging = updatingInnerQuicklook
    && state.request['BUS/http.events.edit'].req.encoderID
    && state.request['BUS/http.events.edit'].req.eventID === eventID
  const requestingAnalytics = getHasRequestPending(state, ['DATA/GET_EVENTS_ANALYTICS'])
  const isExpanded = state.events.expanded.includes(eventID)
  // the event is on its way to starting or stopping, whatever `eventStatus` still says
  const startStopPending = getEventStartStopPending(state, eventID)
  return { requestingEvent, eventViewType, updatingInnerQuicklook, encoderChanging, requestingAnalytics, isExpanded, startStopPending }
}

const mapDispatchToProps = (dispatch) => ({
  getFullEvent: (eventID) => dispatch(actions.data.requestFullEvent(eventID)),
  requestEventAnalytics: eventIDs => dispatch(actions.data.requestEventAnalytics(eventIDs))
})

export default connect(mapStateToProps, mapDispatchToProps)(QuickLook)
